'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convert = undefined;

var _getReverseNumberParts = require('./get-reverse-number-parts');

var _getReverseNumberParts2 = _interopRequireDefault(_getReverseNumberParts);

var _toWords = require('./to-words');

var _toWords2 = _interopRequireDefault(_toWords);

var _addMagnitudes = require('./add-magnitudes');

var _addMagnitudes2 = _interopRequireDefault(_addMagnitudes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convert = function convert(number) {
  if (number > 2 ** 53 - 1) {
    return 'Maximum safe integer in JavaScript exceeded';
  }

  return (0, _getReverseNumberParts2.default)(number).map(_toWords2.default).map(_addMagnitudes2.default).reverse().join(' ').trim();
};

exports.convert = convert;